<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewSettings.pricemarkups.title") }}</h3>
    <v-card class="mt-2" elevation="0">
      <v-row>
        <v-col col="12" lg="3" sm="12" md="6">
          <v-text-field
            v-if="defaultPricemarkup"
            :label="$t('viewSettings.pricemarkups.default_pricemarkup')"
            v-model="defaultPricemarkup.value"
            outlined
            ma-0
            pa-0
            hide-details
            append-icon="fa-save"
            @click:append="
              $store.dispatch('pricemarkups/update', defaultPricemarkup)
            "
            @keyup.enter="
              $store.dispatch('pricemarkups/update', defaultPricemarkup)
            "
          ></v-text-field>
        </v-col>
      </v-row>
      <h3 class="pt-0 mt-5 pb-0">
        {{ $t("viewSettings.pricemarkups.step_pricemarkups") }}
        <v-btn
          color="success"
          class="ml-1 green-shadow"
          x-small
          fab
          max-width="26"
          max-height="26"
          :title="$t('common.add')"
          :to="{ name: 'settings-pricemarkup-create' }"
        >
          <v-icon x-small>$plus</v-icon>
        </v-btn>
      </h3>
      <v-data-table
        :headers="pricesTypesTableHeader"
        :items="pricemarkupsList"
        elevation="0"
        :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
      >
        <template v-slot:footer.page-text="props">
          {{
            $t("tables.x_of_y", [
              `${props.pageStart}-${props.pageStop}`,
              props.itemsLength,
            ])
          }}
        </template>
        <template v-slot:item="props">
          <tr>
            <td class="text-xs-left">
              {{ props.item.source_name }}
            </td>
            <td class="text-xs-left">
              {{ props.item.from_price }}
            </td>
            <td class="text-xs-left">
              {{ props.item.to_price }}
            </td>
            <td class="text-xs-left">
              {{ props.item.value }}
            </td>
            <td class="text-no-wrap text-center">
              <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                color="primary"
                class="mb-0 ml-3 px-0 white--text"
                :title="$t('common.edit')"
                :to="{
                  name: 'settings-pricemarkup-edit',
                  params: { id: props.item.id },
                }"
              >
                <v-icon small>$pencil</v-icon>
              </v-btn>
              <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                color="red lighten-2"
                class="mb-0 ml-3 px-0 white--text"
                :title="$t('common.remove')"
                @click="
                  $store.dispatch('pricemarkups/remove', { id: props.item.id })
                "
              >
                <v-icon small>$trash</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          {{ $t("common.no_data_available") }}
        </template>
        <template v-slot:no-results>
          {{ $t("common.no_data_available") }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import router from "../../router";
import PricemarkupMixin from "@/mixins/pricemarkup";

export default {
  name: "Pricemarkups",
  mixins: [PricemarkupMixin],
  data: () => ({}),
  created() {
    this.onLoad();
  },
  computed: {
    ...mapFields("suppliers", ["suppliers"]),
    ...mapFields("pricemarkups", ["pricemarkups"]),
    pricemarkupsList() {
      let res = this.pricemarkups.filter((item) => item.type !== "default");
      res.forEach((item) => {
        let source = null;
        source = this.types.find((one) => {
          return (
            one.type === item.type &&
            String(one.type_value) === String(item.type_value)
          );
        });
        item.source_name = (source && source.name) || null;
      });
      return res;
    },
    defaultPricemarkup() {
      return this.pricemarkups.find((item) => item.type === "default");
    },
    pricesTypesTableHeader() {
      return [
        {
          text: this.$t("viewSettings.pricemarkups.fields.type"),
          value: "type",
          sortable: true,
        },
        {
          text: this.$t("viewSettings.pricemarkups.fields.from_price"),
          value: "from_price",
          sortable: true,
        },
        {
          text: this.$t("viewSettings.pricemarkups.fields.to_price"),
          value: "to_price",
          sortable: true,
        },
        { text: this.$t("%"), value: "value", sortable: true },
        { text: this.$t("common.actions"), sortable: false, align: "center" },
      ];
    },
    /**
     * это свойство отвечает за сокрытие настроек API поставщиков для не русскоязычных пользователей
     */
    isApiSuppliersConfigVisible(){
      return this.lang === 'ru';
    },
  },
  watch: {
    $route(to, from) {
      this.onLoad();
    },
  },
  methods: {
    onLoad() {
      this.$store.dispatch("pricemarkups/get");
      this.$store.dispatch("suppliers/get");
      this.$store.dispatch("storages/get");
      if(this.isApiSuppliersConfigVisible){
        this.$store.dispatch("suppliers/getSuppliersByAPIWithConfig");
      }
    },
  },
};
</script>

<style scoped></style>
